module.exports = __webpack_public_path__ + "static/media/daxuejy.5b889db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/daxuejy.png
// module id = 652
// module chunks = 0 1